

import { Grid2 as Grid, Typography } from "@mui/material"
import SelectInput from "../../ui/SelectInput"
import { useSelector } from "react-redux"

function DurationSelector({ durationRef }) {
  const { data } = useSelector((state) => state.otherSlice)
  const formattedOptions = [30, 60].map((duration) => ({
    value: duration,
    name: `${duration} mins`,
  }))

  const selectedOption =
    formattedOptions.find(opt => opt.value === data?.slotDuration) || null

  return (
    <>
      <Typography
        fontSize={20}
        fontWeight="600"
        color="other.color1"
        sx={{ mb: 2 }}
      >
        Appointment Slot Duration
      </Typography>
      <Grid size={{ xs: 12, lg: 6, xl: 2 }}>
        <SelectInput
          key={Date.now() + selectedOption}
          renderValueKey="name"
          inputRef={durationRef}
          options={formattedOptions}
          selectLabel="Select Duration"
          defaultValue={selectedOption || "[object Object]"}
        />
      </Grid>

    </>
  )
}

export default DurationSelector